import styled from 'styled-components'

import { Body, Heading2 } from 'components/Typography'
import { TestIDs } from 'test/utils/testIds'
import { style } from 'theme'

export const Container = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
`

export const Title = styled(Heading2)`
  font-size: 22px;
  line-height: 30px;
  color: ${style(theme => theme.colors.slate)};
  margin-bottom: 10px;
`

export const Text = styled(Body)`
  font-size: 14px;
  line-height: 22px;
  margin: 0 auto 20px;
  color: ${style(theme => theme.colors.slate)};
  max-width: 450px;
`

export const LaterText = styled(Body)`
  margin-bottom: 80px;

  @media (max-width: ${style(theme => theme.breakpoints.md)}px) {
    margin-bottom: 80px;
  }

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin-bottom: 60px;
  }
`

export const Image = styled.img.attrs({
  'data-testid': TestIDs.BANK_LINK_SUCCESS.CORE_IMAGE,
})`
  margin: 30px auto 20px;
`

export const BankImageContainer = styled.img`
  width: 50px;
  height: 50px;
  margin-right: 15px;
`

export const LaterImage = styled(Image).attrs({
  'data-testid': TestIDs.BANK_LINK_SUCCESS.LATER_IMAGE,
})`
  margin: 30px auto 20px;
  height: 110px;
  width: 139px;

  @media (max-width: ${style(theme => theme.breakpoints.md)}px) {
    margin-top: 40px;
  }

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin-top: 30px;
  }
`

export const AccountContainer = styled.div`
  width: 315px;
  display: flex;
  align-items: center;
  padding: 20px;
  margin: 0 auto 80px;
  box-shadow: 0px 3px 15px 2px rgba(0, 0, 0, 0.05);
  border-radius: 10px;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    width: 100%;
    margin-bottom: 60px;
  }
`

export const AccountName = styled(Body)`
  color: ${style(theme => theme.colors.slate)};
  line-height: 22px;
  font-weight: 600;
  text-align: left;
`

export const AccountDetails = styled.p`
  color: ${style(theme => theme.colors.stone)};
  font-size: 12px;
  line-height: 16px;
  margin: 0;
  text-align: left;
`

export const CheckIcon = styled.img`
  width: 22px;
  height: 22px;
  margin: 0 0 0 auto;
`
